export default "__VITE_ASSET__DM2nz5iN__"